const mutations = {
    // 全局加载条
    load: (state, load) => {
        state.load = load
    },

    // 参数
    params: (state, params) => {
        state.params = params
    },

    clientWidth: (state, clientWidth) => {
        state.clientWidth = clientWidth
    },

    scrollTop: (state, scrollTop) => {
        state.scrollTop = scrollTop
    },

    banner: (state, res) => {
        state.banner = res
    },

    // 个人信息
    userInfo: (state, res) => {
        state.userInfo = res
    },

    // 是否登录
    islogin: (state, islogin) => {
        state.islogin = islogin
    },

    // 首页选中状态
    activeIndex: (state, activeIndex) => {
        state.activeIndex = activeIndex
    },
}

export default mutations